import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { AppShell } from "@/components/AppShell";
import { OnboardingWizard } from "@/components/OnboardingWizard";
import { useAuth } from "@/hooks/useAuth";
import { UserProvider } from "@/context/UserContext";
import { CandidateProvider } from "@/context/CandidateContext";
import { ApplicationProvider } from "@/context/ApplicationContext";
import { WalkthroughProvider } from "@/components/walkthrough/Walkthrough";

export const Route = createFileRoute("/app")({
  component: AppLayout,
});

function AppLayout() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate({ to: "/login" });
      return;
    }
    // Force plan choice after signup
    if (user) {
      try {
        if (localStorage.getItem("plan_choice_pending") === "1") {
          navigate({ to: "/pricing" });
        }
      } catch { /* ignore */ }
    }
  }, [user, loading, navigate]);

  // Render the shell immediately — don't block on auth.
  // Child routes that need a user will guard themselves.
  return (
    <UserProvider>
      <CandidateProvider>
        <ApplicationProvider>
          <WalkthroughProvider>
            <AppShell>
              {user && <OnboardingWizard />}
              <Outlet />
            </AppShell>
          </WalkthroughProvider>
        </ApplicationProvider>
      </CandidateProvider>
    </UserProvider>
  );
}
